import { Controller } from "@hotwired/stimulus"

// Fetches three name suggestions from POST /company/employees/name_suggestions
// and renders them as click-to-fill chips next to the name field.
//
//   data-controller="name-suggester"
//   data-name-suggester-url-value="/company/employees/name_suggestions"
//   data-name-suggester-role-value="cmo"
//   data-name-suggester-skill-value="cmo-advisor"
//   data-name-suggester-target="input" → the <input> to populate
//   data-name-suggester-target="results" → empty <div> for the chips
//   data-name-suggester-target="button"  → the trigger button (for spinner state)
export default class extends Controller {
  static values  = { url: String, role: String, skill: String }
  static targets = [ "input", "results", "button" ]

  async suggest(event) {
    event.preventDefault()
    if (!this.hasInputTarget) return
    this._setBusy(true)

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const fd    = new FormData()
    fd.append("role",  this._currentRole())
    fd.append("skill", this.skillValue || "")

    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": token, "Accept": "application/json" },
        body: fd,
        credentials: "same-origin"
      })
      const data  = await res.json()
      const names = Array.isArray(data.names) ? data.names : []
      this._renderChips(names)
    } catch (e) {
      this._renderChips([])
    } finally {
      this._setBusy(false)
    }
  }

  // Optional: when the user changes the role dropdown, clear stale chips.
  clear() {
    if (this.hasResultsTarget) this.resultsTarget.replaceChildren()
  }

  _currentRole() {
    if (this.roleValue) return this.roleValue
    const roleEl = document.querySelector('[name="employee[role]"]')
    return roleEl ? roleEl.value : ""
  }

  _renderChips(names) {
    if (!this.hasResultsTarget) return
    this.resultsTarget.replaceChildren()
    if (names.length === 0) {
      const span = document.createElement("span")
      span.className = "text-[10px] text-ink-muted"
      span.textContent = "no suggestions — try again"
      this.resultsTarget.appendChild(span)
      return
    }
    names.forEach(n => {
      const chip = document.createElement("button")
      chip.type = "button"
      chip.className = "text-[11px] px-2 py-1 rounded-full bg-brand-tint text-violet-fg hover:bg-brand-edge transition-colors font-medium"
      chip.textContent = n
      chip.addEventListener("click", () => {
        this.inputTarget.value = n
        this.inputTarget.focus()
        this.resultsTarget.replaceChildren()
      })
      this.resultsTarget.appendChild(chip)
    })
  }

  _setBusy(busy) {
    if (!this.hasButtonTarget) return
    this.buttonTarget.disabled = busy
    if (busy) {
      this._originalLabel = this.buttonTarget.textContent
      this.buttonTarget.textContent = "Thinking…"
    } else if (this._originalLabel) {
      this.buttonTarget.textContent = this._originalLabel
    }
  }
}
